import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
};
export const Reveal: React.FC<Props> = ({
  children,
  delay = 0,
  y = 24,
  className
}) => <motion.div initial={{
  opacity: 0,
  y
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-80px'
}} transition={{
  duration: 1,
  delay,
  ease: [0.22, 1, 0.36, 1]
}} className={className} data-id="element-50">
    {children}
  </motion.div>;